// src/theme.js
import { extendTheme } from "@chakra-ui/react";

const colors = {
  gold: {
    50: "#FFF8DC",
    100: "#FFEBB8",
    200: "#FFDE94",
    300: "#FFD170",
    400: "#FFC44C",
    500: "#DAA520",
    600: "#B8891B",
    700: "#967116",
    800: "#745911",
    900: "#52410C",
  },
  black: {
    100: "#E0E0E0",
    200: "#B3B3B3",
    300: "#808080",
    400: "#4D4D4D",
    500: "#000000",
    600: "#000000",
    700: "#000000",
    800: "#000000",
    900: "#000000",
  },
  gray: {
    50: "#F8F8F8",
    100: "#EDEDED",
    200: "#D1D1D1",
    300: "#B5B5B5",
    400: "#999999",
    500: "#A9A9A9",
    600: "#808080",
    700: "#696969",
    800: "#525252",
    900: "#3B3B3B",
  },
};

const theme = extendTheme({ colors });

export default theme;
